import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  heading: "",
};

const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setHeading: (state, action) => ({
      ...state,
      heading: action.payload,
    }),
  },
});

export const { setHeading } = HeaderSlice.actions;
export default HeaderSlice.reducer;
